import { render, staticRenderFns } from "./ReportNotaIngresoUrpa.vue?vue&type=template&id=40fdbb7c"
import script from "./ReportNotaIngresoUrpa.vue?vue&type=script&lang=js"
export * from "./ReportNotaIngresoUrpa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports